
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ModeService } from './mode.service';
import { ErrorHandlingService } from './error-handling.service';
import { SwalAlert } from '../helpers/alert';
import { ReportDto } from '../dtos/report-dto-model';
import { ReportLogDto } from '../dtos/reportLog-dto-model';

@Injectable({
  providedIn: 'root'
})

export class ReportService {
  http: any;

constructor(
    private readonly _httpClient: HttpClient,
    private readonly _modeService: ModeService,
    private readonly _configService: ConfigService,
    private readonly errorHandlingService: ErrorHandlingService
  ) {
  }
 
  swalAlert = new SwalAlert();
  
  async getReports(): Promise<ReportDto[] | null>{
    return new Promise( resolve => {
      const message = 'Getting Reports';
      this._modeService.addToWaitList(message);
      this._httpClient.get<ReportDto[] | null>(`${this._configService.apiUrl}/Report/GetReports`).subscribe({
        next: data => {
          this._modeService.removeFromWaitList(message);
          resolve(data);
        }, 
        error: async e => {
          console.log(e);
          this._modeService.removeFromWaitList(message);
          await this.swalAlert.alert('Error getting Reports');
          resolve(null);
        } 
      });
    });    
  }
  async saveReportLogs(reportLogDto:ReportLogDto): Promise<any>{
    return new Promise( resolve => {
      const message = 'Saving Report Logs';
      //this._modeService.addToWaitList(message);
      this._httpClient.post<ReportLogDto>(`${this._configService.apiUrl}/Report/SaveReportLog`,reportLogDto).subscribe({
        next: data => {
          //this._modeService.removeFromWaitList(message);
          resolve(data);
        }, 
        error: async e => {
          console.log(e);
          this._modeService.removeFromWaitList(message);
          await this.swalAlert.alert(this.errorHandlingService.getErrorMessage(e));
          resolve(null);
        } 
      });
    });    
  }
}
